'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'clsx';
import { useWindowSize } from 'hamo';
import { useGlobalPageTransition } from '~/components/page-transition/context';
import { useDeviceDetection } from '~/hooks/use-device-detection';
import { desktopVW, mobileVW } from '~/libs/utils';
import s from './global-transition.module.css';
import { onAfterEnter, onBeforeEnter, onBeforeExit } from './transition';
const globalTransitionPages = ['/', '/work', '/about', '/read', '/store', '/contact'];
export function GlobalTransition() {
  const $ = _c(8);
  const {
    height: t0,
    width: t1
  } = useWindowSize();
  const windowHeight = t0 === undefined ? 0 : t0;
  const windowWidth = t1 === undefined ? 0 : t1;
  const {
    isDesktop
  } = useDeviceDetection();
  const textlinesCount = Math.ceil(isDesktop ? windowHeight / desktopVW(106, windowWidth) : windowHeight / mobileVW(80, windowWidth));
  let t2;
  if ($[0] !== textlinesCount) {
    t2 = Array.from({
      length: textlinesCount
    }, _temp);
    $[0] = textlinesCount;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const textlines = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      onBeforeExit,
      onBeforeEnter,
      onAfterEnter,
      pages: globalTransitionPages
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useGlobalPageTransition(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn(s.container, "fixed inset-0 z-50 pointer-events-none banner overflow-hidden flex items-end");
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div id="curtain-content-bg" className={cn(s.background, "absolute inset-0 bg-primary")} />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== textlines || $[6] !== textlinesCount) {
    t6 = <div id="curtain" className={t4}><div id="curtain-content" className="relative px-safe flex flex-col sgap-10 dt:sgap-20 dt:spt-20 min-h-screen w-full" suppressHydrationWarning={true}>{t5}{textlines.map((line, idx) => <p key={`curtain-text-line-${textlinesCount}-${line}`} className={cn("relative flex whitespace-nowrap", idx !== textlines.length - 1 && "curtain-text-line", (() => {
          if (textlines.length % 2 === 0) {
            return idx % 2 === 0 ? "curtain-text-line-right" : "curtain-text-line-left";
          }
          return idx % 2 === 0 ? "curtain-text-line-left" : "curtain-text-line-right";
        })())}><span className="absolute right-full curtain-line dt:smr-200" /><span className="curtain-line dt:smr-200" /><span className="curtain-line dt:smr-200" /></p>)}</div></div>;
    $[5] = textlines;
    $[6] = textlinesCount;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}
function _temp(_, i) {
  return i;
}